import React from "react";
import {
  Box,
  Typography,
  OldButton as Button,
  Stack,
  Spacer,
  Divider,
} from "digiwash-components";
import Icon from "../../components/Icon";
import { SectionDataType } from "../../types/server";
import styled from "styled-components/native";
import { color } from "@sloth-system/styled-utils";
import CustomIcon from "../../components/CustomIcon";

const Container = styled(Box)`
  border: 1px solid ${color("primary.light930")};
`;

interface SectionListType {
  data: SectionDataType[];
  onSubmit: (item: SectionDataType) => void;
}

function SectionList(props: SectionListType) {
  return (
    <Container p="l" br="l" bg="primary.light950">
      {props.data.map((item, index) => {
        return (
          <>
            {item.hide ? null : (
              <>
                <Button
                  onPress={() => {
                    props.onSubmit(item);
                  }}
                >
                  <Stack distribution="space-between">
                    <Stack>
                      <CustomIcon icon={item.icon} width={24} height={24} />
                      <Spacer size="m" />
                      <Typography
                        ff="mainMedium"
                        fs="xm"
                        color={item.textColor || "common.black"}
                      >
                        {item.title}
                      </Typography>
                    </Stack>
                    <Icon name="chevron-left" size={24} />
                  </Stack>
                </Button>
                {index + 1 === props.data.length ? null : (
                  <Divider size="xxxl" />
                )}
              </>
            )}
          </>
        );
      })}
    </Container>
  );
}

export default SectionList;
